import TID1500 from "./TID1500";
import TID300 from "./TID300";
import message from "./Message";
import addAccessors from "./addAccessors";
import * as orientation from "./orientation";
import * as compression from "./compression/rleSingleSamplePerPixel";

const utilities = {
    TID1500,
    TID300,
    message,
    addAccessors,
    orientation,
    compression
};

export default utilities;
